export default [
    {
        name: 'link',
        sortField: 'link',
        type: 'string',
        useInFilter: true,
        isDefault: true,
        defaultSearch: true
    }

]